"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var text_field_style_component_1 = require("./text-field.style.component");
var styled_components_1 = __importDefault(require("styled-components"));
var TextAreaInput = styled_components_1.default.textarea(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  padding: 6px 8px;\n  box-sizing: border-box;\n"], ["\n  ", ";\n  padding: 6px 8px;\n  box-sizing: border-box;\n"])), text_field_style_component_1.baseInputStyle);
TextAreaInput.displayName = 'TextAreaInput';
exports.TextArea = function (props) {
    var onChange = props.onChange, title = props.title, invalid = props.invalid, disabled = props.disabled, placeholder = props.placeholder, value = props.value, multiline = props.multiline, rows = props.rows, cols = props.cols, id = props.id;
    function onChangeHandler(event) {
        if (onChange) {
            var value_1 = event.target.value;
            onChange(value_1);
        }
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        title && react_1.default.createElement(text_field_style_component_1.Title, { htmlFor: id }, title),
        react_1.default.createElement(text_field_style_component_1.InputContainer, null,
            react_1.default.createElement(TextAreaInput, { id: id, invalid: invalid, onChange: onChangeHandler, disabled: disabled, placeholder: placeholder, value: value, multiline: multiline, rows: rows, cols: cols }))));
};
exports.TextArea.displayName = 'TextArea';
exports.default = exports.TextArea;
var templateObject_1;
